/**
 * @generated SignedSource<<c3853cde9b40b53a39319810341b1145>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PostNoteToZoomInput = {
  clientMutationId?: string | null;
  includeAiSummary?: boolean | null;
  message: string;
  noteId: string;
  zoomChannel?: string | null;
  zoomMember?: string | null;
};
export type SendNotesModalPostToZoomMutation$variables = {
  input: PostNoteToZoomInput;
};
export type SendNotesModalPostToZoomMutation$data = {
  readonly postNoteToZoom: {
    readonly ok: boolean;
  } | null;
};
export type SendNotesModalPostToZoomMutation = {
  response: SendNotesModalPostToZoomMutation$data;
  variables: SendNotesModalPostToZoomMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostNoteToZoomPayload",
    "kind": "LinkedField",
    "name": "postNoteToZoom",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendNotesModalPostToZoomMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendNotesModalPostToZoomMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "97549b0240c143d19831e0c838e33bbb",
    "id": null,
    "metadata": {},
    "name": "SendNotesModalPostToZoomMutation",
    "operationKind": "mutation",
    "text": "mutation SendNotesModalPostToZoomMutation(\n  $input: PostNoteToZoomInput!\n) {\n  postNoteToZoom(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "91847349550f855b0454a57745479e58";

export default node;
